import { z } from 'zod';

export const PostSessionResponseDTO = z.object({
  sessionId: z.string(),
  UserId: z.string(),
});

// eslint-disable-next-line no-redeclare
export type PostSessionResponseDTO = z.infer<typeof PostSessionResponseDTO>;
